import styled from "styled-components";
import { Link } from "react-router-dom";

/**
 * Wrapper principal do cabeçalho (Desktop)
 */
export const HeaderWrapper = styled.header`
  height: ${({ theme }) => theme.spacing(20)};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  max-width: 100%;
  margin: 0 auto;
  max-height: 120px;
`;

/**
 * Wrapper do logotipo
 */
export const LogoWrapper = styled.a`
  /* flex: 1; */
  width: fit-content;
  margin-left: 10%;
`;

/**
 * Wrapper da navegação
 */
export const NavWrapper = styled.nav`
  flex: 1;
  display: flex;
  justify-content: center;
  align-self: center;
  width: fit-content;
  align-self: center;
  /* background-color: aqua; */
`;

/**
 * Wrapper do botão ou banner de ação
 */
export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
  margin-right: 10%;
  white-space: nowrap;
`;

export const HeaderAction = styled.button`
  min-height: ${({ theme }) => theme.spacing(10)};
  padding: 0 ${({ theme }) => theme.spacing(4)};
  border: 0;
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.yellow};
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  cursor: pointer;
  transition: filter 0.2s ease-in-out;

  svg {
    width: ${({ theme }) => theme.spacing(5)};
    height: ${({ theme }) => theme.spacing(5)};
  }

  &:hover {
    filter: brightness(0.95);
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.darkBlue};
    outline-offset: 2px;
  }
`;

export const LoginAction = styled.a`
  color: ${({ theme }) => theme.colors.mediumGray};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  transition: color 0.2s ease-in-out;

  svg {
    width: ${({ theme }) => theme.spacing(7)};
    height: ${({ theme }) => theme.spacing(7)};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.vividBlue};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.darkBlue};
    outline-offset: 4px;
  }
`;

export const AccountMenuWrapper = styled.div`
  position: relative;
`;

export const AccountMenu = styled.div`
  position: absolute;
  z-index: 20;
  top: calc(100% + ${({ theme }) => theme.spacing(3)});
  right: 0;
  width: 280px;
  padding: ${({ theme }) => theme.spacing(2)};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: ${({ theme }) => theme.borderRadius.large};
  background: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.light.large};
`;

const accountItemStyles = `
  width: 100%;
  min-height: 44px;
  padding: 10px 12px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #484848;
  font: inherit;
  font-size: 0.9rem;
  text-align: left;
  text-decoration: none;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover, &:focus-visible {
    background: #EBFAFF;
    color: #2789B3;
    outline: none;
  }
`;

export const AccountMenuLink = styled(Link)`
  ${accountItemStyles}
`;

export const AccountMenuButton = styled.button`
  ${accountItemStyles}
  color: ${({ theme }) => theme.colors.red};
  border-top: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: 0 0 ${({ theme }) => theme.borderRadius.medium}
    ${({ theme }) => theme.borderRadius.medium};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;
